import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";

const productTypesAtom = atom([]);

const useProductTypes = () => {
  const [productTypes, setProductTypes] = useAtom(productTypesAtom);

  const onGetProductTypes = () => {
    dataService.get(`constants/types-contrat`, (data) => {
      setProductTypes((data || []).map(({ id, nom }) => ({ id, name: nom })));
    });
  };

  return {
    productTypes,
    onGetProductTypes,
  };
};

export default useProductTypes;
